export default __webpack_public_path__ + "static/logical-resources-logo-e6e08f3580c5720ea400a7e42db1f91e.png";